export const TEST_IDS = {
  authorizeUserCard: 'authorize-user-card',
  toast: 'toast',
  accountName: 'account-name',
  accountEmail: 'account-email',
  resendCodeCountdown: 'resend-code-countdown',
}
